const DEFAULT_INITIALS_COUNT = 2;
const TEXT_SYMBOL_PATTERN = /[\p{L}\p{N}]/u;

export function extractInitials(value: string, maxInitials: number = DEFAULT_INITIALS_COUNT): string {
  if (!value) return '';

  const sanitizedValue: string = value
    .replace(/[()]/g, '')
    .trim();

  if (!sanitizedValue) return '';

  const parts: string[] = sanitizedValue.split(/\s+/);
  const hasTextSymbols: boolean = parts.some((part: string) => findFirstTextSymbol(part).length > 0);

  return parts
    .map((part: string) => hasTextSymbols ? findFirstTextSymbol(part) : getFirstSymbol(part))
    .filter((part: string) => part.length > 0)
    .slice(0, maxInitials)
    .join('')
    .toUpperCase();
}

export function buildAvatarInitials(...parts: Array<string | null | undefined>): string {
  return extractInitials(
    parts
      .filter(isNonEmptyString)
      .join(' ')
  );
}

export function buildAvatarSvgDataUrl(...parts: Array<string | null | undefined>): string {
  const initials: string = escapeSvgText(buildAvatarInitials(...parts));
  const backgroundColor: string = 'white';
  const textColor: string = 'black';

  const svgCode: string =
    `<svg xmlns="http://www.w3.org/2000/svg"
               width="40"
               height="40"
               viewBox="0 0 40 40">
            <circle cx="20"
                    cy="20"
                    r="20"
                    fill="${backgroundColor}" />
            <text x="50%"
                  y="55%"
                  dominant-baseline="middle"
                  text-anchor="middle"
                  font-family="Roboto, sans-serif"
                  font-weight="600"
                  font-size="17"
                  fill="${textColor}">
             ${initials}
            </text>
          </svg>`;

  const encodedData: string = (typeof window !== 'undefined') ? toBase64Unicode(svgCode) : '';
  return `data:image/svg+xml;base64, ${encodedData}`;
}

function findFirstTextSymbol(value: string): string {
  for (const symbol of value) {
    if (TEXT_SYMBOL_PATTERN.test(symbol)) {
      return symbol;
    }
  }

  return '';
}

function getFirstSymbol(value: string): string {
  for (const symbol of value) {
    return symbol;
  }

  return '';
}

function isNonEmptyString(value: string | null | undefined): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

function escapeSvgText(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function toBase64Unicode(str: string): string {
  const bytes: Uint8Array = new TextEncoder().encode(str);
  let binaryString: string = '';

  bytes.forEach((byte: number): void => {
    binaryString += String.fromCharCode(byte);
  });

  return btoa(binaryString);
}
